export const PLACE = "Place";
export const FOOD = "Food";
export const HOTEL = "Hotel";
export const ALL = "All";